import request from '@/utils/request'

/** 用户列表 */
export function getUserList(keyword, realName, accountStatus, page = 1, size = 10) {
  return request({
    url: '/manage/user/list',
    method: 'post',
    params: { keyword, realName, accountStatus, page, size }
  })
}

/** 实名认证审核列表 */
export function getVerificationList(keyword, verifyStatus, page = 1, size = 10) {
  return request({
    url: '/manage/user/verification/list',
    method: 'post',
    params: { keyword, verifyStatus, page, size }
  })
}

/**
 * 修改认证类型和过期时间（一起提交）
 * @param {number} id - 认证记录ID
 * @param {object} data - { personType: '', expireAt: '2027-08-19 18:00:00' }
 */
export function updateVerification(data) {
  return request({
    url: `/manage/user/verification/update`,
    method: 'post',
    data
  })
}

/** 认证通过 */
export function approveVerification(id) {
  return request({
    url: `/manage/user/verification/approve/${id}`,
    method: 'post'
  })
}

/** 认证驳回 */
export function rejectVerification(id, reason) {
  return request({
    url: `/manage/user/verification/reject/${id}`,
    method: 'post',
    data: { reason }
  })
}

/** 封禁用户 */
export function banUser(id, reason, days) {
  return request({
    url: `/manage/user/ban/${id}`,
    method: 'post',
    data: { reason, days }
  })
}

/** 解封用户 */
export function unbanUser(id) {
  return request({
    url: `/manage/user/unban/${id}`,
    method: 'post'
  })
}


/** 人群类型字典列表 */
export function getPersonTypeList() {
  return request({
    url: '/personTypes/list',
    method: 'post',
  })
}
